// extracted by mini-css-extract-plugin
module.exports = {"container":"sticky-container_container__FNSI1","is-stickied":"sticky-container_is-stickied__xwOYH"};